/* Remove this file during FF: sign_core_2026_01_07_advanced_sig_frame cleanup */
import React from 'react';
import styles from 'signer-app/signature-request/display-field/signature.module.css';
import { useSignatureModalContext } from 'signer-app/signature-modal/signature-modal-context/context';

interface ImageProps {
  alt?: string;
  id: string;
  isFormView?: boolean;
}

const Image = React.forwardRef<any, ImageProps>(
  ({ isFormView, alt = '', id, ...props }, ref) => {
    const signatureProps = useSignatureModalContext();
    const src = signatureProps.getSignatureUrl({ guid: id });
    const className = isFormView ? styles.formViewImage : styles.image;
    return (
      <div
        {...props}
        ref={ref}
        style={{
          height: '100%',
          width: '100%',
          cursor: 'auto',
          boxSizing: 'border-box',
        }}
      >
        <img alt={alt} className={className} src={src} />
      </div>
    );
  },
);
Image.displayName = 'Image';

/**
 * @deprecated Use Image from './image-components/image' instead.
 */
export default Image;
